<template>
  <div id="" class="mainDiv">
    <h3 class="p">签退</h3>
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="课程名称：">
        <p>{{ form.courseName }}</p>
      </el-form-item>
      <el-form-item label="学生：">
        <p>{{ form.name }}</p>
      </el-form-item>
      <el-form-item label="面授时间：" class="contact_time">
        {{ form.beginDate | timeadd(0) }}
        <br />
        <span class="contact_time_to">至</span>
        <br />
        {{ form.endDate | timeadd(0) }}
      </el-form-item>
      <el-form-item label="签到状态：">
        <p>签到成功</p>
      </el-form-item>
      <el-form-item label="签到时间：">
        <p>{{ form.signDate | datetimeFormat }}</p>
      </el-form-item>
      <el-form-item label="签退状态：">
        <p>签退成功</p>
      </el-form-item>
      <el-form-item label="签退时间：">
        <p>{{ form.signOutDate | datetimeFormat }}</p>
      </el-form-item>
    </el-form>
    <div v-if="form.signOutStatus == 1" class="success">
      <p>签退成功</p>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/attendance/mobile";
export default {
  name: "GongzhonghaoSignin",
  data() {
    return {
      sigoutSuccess: 2,
      form: {
        courseName: "",
        liveTime: "",
        name: "",
        signDate: "",
        status: "",
        beginDate: "",
        endDate: "",
          signOutDate:'',
      },
    };
  },
    filters: {
        timeadd: function (value1, value2) {
            let newTime = parseInt(value1) + parseInt(value2) * 60
            // return new Date(parseInt(newTime) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ');
            function add0(m) {
                return m < 10 ? '0' + m : m
            }
            var time = new Date(newTime * 1000)
            var y = time.getFullYear()
            var m = time.getMonth() + 1
            var d = time.getDate()
            var h = time.getHours()
            var mm = time.getMinutes()
            var s = time.getSeconds()
            return (
                y +
                '-' +
                add0(m) +
                '-' +
                add0(d) +
                ' ' +
                add0(h) +
                ':' +
                add0(mm) +
                ':' +
                add0(s)
            )
        },
    },
  methods: {
    // tab切换
    handleClick() {
      this.pageObj.page = 1;
      // this.getList()
    },
    goBack() {
      window.history.go(-1);
    },
  },
  created() {
    this.form = this.$route.query.obj;
  },
  computed: {
    getUId() {
      return localStorage.getItem("uid") || "36";
    },
  },
};
</script>

<style lang="scss" scoped>
.qrcodeimg {
  width: 50%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.h,
.p {
  text-align: center;
}
/deep/.el-form-item {
  margin-bottom: 0px;
}
.success {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #8acbc5;
  position: relative;
  margin: auto;
  margin-top: 40px;
}
.success > p {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  white-space: nowrap;
  color: white;
}
/deep/ .contact_time {
  .el-form-item__content {
    margin-top: 12px;
    line-height: 16px;
    .contact_time_to {
      margin-left: 62px;
    }
  }
}
</style>
